import React from "react";
import { cn } from "@/lib/utils";
import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

interface DateCellProps {
  date?: Date | null;
  className?: string;
  timeClassName?: string;
}

export const DateCell: React.FC<DateCellProps> = ({
  date,
  className,
  timeClassName,
}) => {
  if (!date) {
    return <div className={cn("text-center", className)}>-</div>;
  }

  const formatDate = (date: Date) => {
    return format(date, "dd.MM.yyyy");
  };

  const formatTime = (date: Date) => {
    return formatInTimeZone(date, "UTC", "HH:mm");
  };

  return (
    <div
      className={cn(
        "flex flex-col gap-1 justify-center items-center text-[10px]",
        className,
      )}
    >
      <span>{formatDate(date)}</span>
      <span className={cn("text-neutral-500", timeClassName)}>
        {formatTime(date)}
      </span>
    </div>
  );
};
